import { render, staticRenderFns } from "./AgendaView.vue?vue&type=template&id=a8b4c88c&"
import script from "./AgendaView.js?vue&type=script&lang=js&"
export * from "./AgendaView.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports